module.exports = __webpack_public_path__ + "img/readingtask2passage.8fcbfff6.png";